import { createSlice } from "@reduxjs/toolkit";
import {
  AddUserPlan,
  DeleteUserPlan,
  GetAllUserPlan,
  GetUserPlanDetail,
  UpdateUserPlan,
} from "store/middlewares/dataManagement/UserPlan";

export const userPlanSlice = createSlice({
  name: "userplan",
  initialState: {
    userPlanLoading: false,
    userPlan: null,
    userPlanDetail: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllUserPlan.pending, (state) => {
        state.userPlanLoading = true;
        state.userPlan = null;
      })

      .addCase(GetAllUserPlan.fulfilled, (state, action) => {
        state.userPlanLoading = false;
        //state.holiday = action.payload.response;
        const userPlan = action.payload.response;
        state.userPlan = { data: userPlan };
      })

      .addCase(GetAllUserPlan.rejected, (state) => {
        state.userPlanLoading = false;
        state.userPlan = null;
      })

      .addCase(AddUserPlan.fulfilled, (state, action) => {
        state.userPlanLoading = false;
        const userPlan = action.payload.response;
        state.userPlan = { data: userPlan };
      })

      // Update plan
      .addCase(UpdateUserPlan.fulfilled, (state, action) => {
        state.userPlanLoading = false;
        state.userPlan = {
          data: state.userPlan.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item,
          ),
        };
      })

      //Delete plan
      .addCase(DeleteUserPlan.fulfilled, (state, action) => {
        state.userPlanLoading = false;
        const userPlan = action.payload.response;
        state.userPlan.data = state.userPlan.data?.filter(
          (plan) => plan.id !== userPlan?.id,
        );
      })
      .addCase(GetUserPlanDetail.pending, (state) => {
        state.userPlanDetail = null;
      })

      .addCase(GetUserPlanDetail.fulfilled, (state, action) => {
        state.userPlanDetail = action.payload.response;
      })

      .addCase(GetUserPlanDetail.rejected, (state) => {
        state.userPlanDetail = null;
      });
  },
});
export default userPlanSlice.reducer;
